
<div class="SelectedRoutePoints">
  <div class="level is-mobile SelectedRoutePoints__header">
    <div class="level-left">
      <h2 class="title is-6">Wybrane punkty</h2>
    </div>
    <div class="level-right">
      <b-tag type="is-info">{{ points.length }}</b-tag>
    </div>
  </div>

  <div v-if="!points.length" class="SelectedRoutePoints__empty">
    Kliknij marker na mapie, aby dodać punkt do trasy.
  </div>

  <draggable
      v-else
      :value="points"
      @input="$emit('input', $event)"
      tag="ul"
      handle=".SelectedRoutePoints__drag"
      class="SelectedRoutePoints__list"
  >
    <li
        v-for="(point, index) in points"
        :key="point.key"
        class="SelectedRoutePoints__item"
        :class="{ 'has-conflict': isConflict(point), 'is-permanent': point.isPermanent }"
    >
      <button
          type="button"
          class="button is-small is-white SelectedRoutePoints__drag"
          title="Przenieś"
      >
        <i class="mdi">sort</i>
      </button>
      <span class="SelectedRoutePoints__index">{{ index + 1 }}</span>
      <div class="SelectedRoutePoints__body">
        <div class="SelectedRoutePoints__name">
          <strong>{{ point.name }}</strong>
          <b-tag v-if="point.isPermanent" type="is-warning" size="is-small">punkt stały</b-tag>
          <b-tag v-else type="is-light" size="is-small">zamówienie</b-tag>
        </div>
        <p class="SelectedRoutePoints__address">{{ point.address || 'Brak adresu' }}</p>
        <p v-if="!point.hasCoordinates" class="SelectedRoutePoints__warning">
          <i class="mdi">warning</i> Brak poprawnych wspolrzednych.
        </p>
        <p v-if="getConflict(point)" class="SelectedRoutePoints__conflict">
          {{ formatConflict(getConflict(point)) }}
        </p>
        <p v-if="point.isPermanent">
          <b-field class="SelectedRoutePoints__desc">
            <b-input
                type="textarea"
                rows="4"
                placeholder="Napisz co należy wykonać w tym punkcie..."
                :value="point.description"
                @input="updateDescription(point, $event)"
            />
          </b-field>
        </p>
      </div>
      <button
          type="button"
          class="button is-small is-danger is-outlined SelectedRoutePoints__remove"
          @click="$emit('remove', point)"
          title="Usuń punkt"
      >
        <i class="mdi">close</i>
      </button>
    </li>
  </draggable>
</div>
